











































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ModuleActions } from '@/models/Enums';
import { IModule } from '@/models/Modules';

@Component
export default class Module extends Vue {
  @Prop() data!: IModule;
  @Prop({ default: () => [] }) moduleActions!: string[];

  public deleted = false;
  public locked = this.data.locked || false;

  get showLink() {
    return this.moduleActions?.indexOf(ModuleActions.Link) !== -1 && !this.locked;
  }

  get showDelete() {
    return this.moduleActions?.indexOf(ModuleActions.Delete) !== -1;
  }

  get showEdit() {
    return this.moduleActions?.indexOf(ModuleActions.Edit) !== -1;
  }

  get showEditName() {
    return this.moduleActions?.indexOf(ModuleActions.EditName) !== -1;
  }

  get showLock() {
    return this.moduleActions?.indexOf(ModuleActions.Lock) !== -1;
  }

  get getTileUrl() {
    if (this.showLink) {
      return this.data.url;
    }

    return '#';
  }

  public goToUrl(e: Event) {
    if (this.showLink) {
      return true;
    }

    e.preventDefault();
    return false;
  }

  public deleteModule() {
    if (confirm('Weet je het zeker?')) {
      this.deleted = true;
      this.$emit('deleteModule', this.data.id);
    }
  }

  public editModule() {
    this.$emit('editModule', this.data);
  }

  public editClassroomModuleName() {
    this.$emit('editClassroomModuleName', this.data.id);
  }

  public toggleLockModule() {
    this.locked = !this.locked;
    this.$emit('refChanged', {
      id: this.data.id,
      locked: this.locked,
    });
  }
}
